import axios from "axios";
import env from "@/env";
import router from "@/router";
import {notifyError} from "@/components/composables/messages";

const http = axios.create({
    baseURL: env.apiv1 + 'professional/',
});

// Função que retorna o token atualizado
function getToken() {
    return localStorage.getItem('token');
}

// Adicionando um interceptador de requisição ao Axios
http.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Adicionando um interceptador de resposta para lidar com erros
http.interceptors.response.use(
    (response) => {
        // Se a resposta for bem-sucedida, simplesmente a retorne
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            // Código 401 - Unauthorized
            notifyError('Não autorizado!');
            localStorage.removeItem('token'); // Remove o token do localStorage
            router.push('/login'); // Redireciona o usuário para a página de login
        } else {
            // Retorna a Promise rejeitada para que o erro possa ser tratado caso necessário
            return Promise.reject(error);
        }

    }
);

export default http;
